function Terms() {
  return (
    <div class="indented">
      <p id="1271ff38-e4e5-8175-ac40-dd198cb76a63" class="">
        <strong>제1장 총칙</strong>
      </p>
      <p id="1271ff38-e4e5-8100-983d-d35a14b32ddf" class="">
        <strong>제1조 (목적)</strong>
      </p>
      <p id="1271ff38-e4e5-81a0-828b-f84a985d8d45" class="">
        이 약관은 주식회사 딥플랩스(이하 “회사”)에서 제공하는 회원 매칭 어플리케이션인 “딥플
        앱” 및 “딥플”에서 제공하는
        서비스(이하 “서비스”)의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>
      <p id="1271ff38-e4e5-8165-81f8-ff3f98371c26" class="">
        <strong>제2조 (용어의 정의)</strong>
      </p>
      <p id="1271ff38-e4e5-81dc-85af-c248aa57cd41" class="">
        ① 이 약관에서 사용하는 정의는 다음과 같습니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-81d8-b54a-e13c7c74cf81"
        class="numbered-list"
        start="1"
      >
        <li>
          “서비스”라 함은 회사가 회원에게 제공하는 “딥플
          앱“ 및 이에 부수된 제반 서비스를 의미합니다.
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8178-bbdf-fd027802da6d"
        class="numbered-list"
        start="2"
      >
        <li>
          “회원”이라 함은 본 약관에 동의하고 서비스 이용 자격을 부여받은 개인을 의미합니다.
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8170-af41-ed1074988ad6"
        class="numbered-list"
        start="3"
      >
        <li>
          “게시물”이라 함은 회원이 서비스를 이용함에 있어 회원이 게시한 문자, 문서, 그림, 음성, 영상 또는 이들의 조합으로 이루어진 모든 정보를 말합니다.
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81dd-84db-d136ac6190e2"
        class="numbered-list"
        start="4"
      >
        <li>
          “아이템”이라 함은 서비스를 이용 또는 구매하기 위해 사용되는 가상의 데이터로서 회원이 대금을 지급하고 구입하는 것을 말합니다.
        </li>
      </ol>
      <p id="1271ff38-e4e5-8148-bea3-c7d81eff7ec6" class="">
        5. “포인트”이라 함은 서비스를 이용 또는 구매하기 위해 사용되는 가상의 데이터로서 회사가 임의로 책정하고 무료로 지급하는 일체의 재산적 가치가 없는 것을 말합니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-816b-908f-fa9344b0002b"
        class="numbered-list"
        start="1"
      >
        <li>
          “이메일“이라 함은 서비스 이용 및 회원의 식별을 위하여 회원이 작성하고
          회사가 부여한 인증번호를 통해 인증을 완료한 문자 및 숫자의 조합으로
          이루어진 정보를 말합니다.
        </li>
      </ol>
      <p id="1271ff38-e4e5-81a1-9110-c0edc86e4475" class="">
        ② 이 약관에서 사용하는 용어의 정의는 제1항 각호에서 정하는 것을 제외하고는 관계법령 및 기타 일반적인 상관례에 의합니다.
      </p>
      <p id="1271ff38-e4e5-81e7-aa5a-cb3ce3c31068" class="">
        <strong>제3조 (약관의 명시와 개정)</strong>
      </p>
      <p id="1271ff38-e4e5-8160-aa0c-fdb98d30e4e9" class="">
        ① 회사는 이 약관의 내용을 회원이 알 수 있도록  초기 화면이나 연결화면을 제공하는 방법으로 회원에게 공지합니다.
      </p>
      <p id="1271ff38-e4e5-8197-ab09-f408bc9d5398" class="">
        ② 회사가 약관을 개정할 경우에는 적용일자 및 개정내용, 개정사유 등을 명시하여 그 적용일자로부터 최소한 7일 이전(회원에게 불리하거나 중대한 사항의 변경은 30일 이전)부터 그 적용일자 경과 후 상당한 기간이 경과할 때까지 초기화면 또는 연결화면을 통해 공지합니다.
      </p>
      <p id="1271ff38-e4e5-81eb-b298-f769ac990073" class="">
        ③ 회사가 약관을 개정할 경우에는 개정약관 공지 후 개정약관의 적용에 대한 회원의 동의 여부를 확인합니다. 개정약관 공지
        시 회원이 동의 또는 거부의 의사표시를 하지 않으면 승낙한 것으로 간주
        하겠다는 내용도 함께 공지한 경우에는 회원이 약관 시행일 까지 거부의사를 표시하지 않는다면 개정약관에 동의한 것으로 간주할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8180-a252-d460526e7c6d" class="">
        ④ 회원이 개정약관의 적용에 동의하지 않는 경우 회사 회사에서 제공하는
        서비스 이용 중단 페이지에서 탈퇴 의사를 표시하고
        서비스 이용종료를 요청할 수 있습니다. 다만, 회사가 회원에게 변경된
        약관의 내용을 통보한 경우 회원이 위 통보일로부터 30일 이내 거부의
        의사표시를 하지 아니한 경우 회원이 변경된 약관에 동의하는 것으로 봅니다.
      </p>
      <p id="1271ff38-e4e5-81aa-bbb0-dae25295b38e" class="">
        <strong>제4조 (약관 외 준칙)</strong>
      </p>
      <p id="1271ff38-e4e5-8172-9f73-e734b0bd46f8" class="">
        본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시 되지
        아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.
      </p>
      <p id="1271ff38-e4e5-81a8-819b-c3284c42c29f" class="">
        <strong>제5조 (운영정책)</strong>
      </p>
      <p id="1271ff38-e4e5-81c4-961f-eb39afc6316c" class="">
        ① 약관을 적용하기 위하여 필요한 사항과 서비스 내 질서를 유지하기 위하여 회사는 약관에서 구체적 범위를 정하여 위임한 사항을 서비스 운영정책(이하 “운영정책”이라 합니다)으로 정할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-81dd-a71a-d6c594c872d0" class="">
        ② 회원의 권리 또는 의무에 중대한 변경을 가져오거나 약관 내용을 변경하는  것과 동일한 효력이 발생하는 운영정책 개정의 경우에는 제3조
        제2항의 절차에 따릅니다.
      </p>
      <p id="1271ff38-e4e5-814e-a8b5-fd1f7bcc0ec1" class="">
        <strong>제2장 서비스의 이용 및 종료</strong>
      </p>
      <p id="1271ff38-e4e5-81a5-aa78-cb06f2f2f742" class="">
        <strong>제6조 (이용신청 및 이용신청의 승낙과 제한)</strong>
      </p>
      <p id="1271ff38-e4e5-810c-9f92-e87000e87fad" class="">
        ① 회사가 제공하는 서비스를 이용하고자 하는 회원은 이용약관에 동의 후
        회사가 제공하는 가입 페이지를 이용하여 가입신청을 하고 신청한 내용에
        대해 회사의 승인 이후 계약이 체결됩니다.
      </p>
      <p id="1271ff38-e4e5-8148-8602-f517725051f2" class="">
        ② 가입신청시 회사는 다음 각 호에 해당하는 신청에 대해서 가입신청을
        승낙하지 않거나 사후에 이용계약을 해지할 수 있습니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-81d8-8b9e-dc92a2270aae"
        class="numbered-list"
        start="1"
      >
        <li>
          음란물 유포 및 욕설이 포함된 정보를 등록하여 타인에게 불편함을 주는
          경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8182-878b-da99425e8b6b"
        class="numbered-list"
        start="2"
      >
        <li>
          타인의 명의를 도용하거나 제 3자의 정보를 이용하여 중복가입을 하는 경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8177-9a4f-ed13a4ee94eb"
        class="numbered-list"
        start="3"
      >
        <li>
          기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이
          부적당하다고 인정하는 경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8128-ba6d-f8eb18e5071a"
        class="numbered-list"
        start="4"
      >
        <li>부정한 용도로 서비스를 이용하고자 하는 경우</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8156-971c-c61b90916896"
        class="numbered-list"
        start="5"
      >
        <li>
          타인에게 불쾌감을 주거나 얼굴 식별이 어려운 저화질의 사진을 사용하는
          경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8117-84d2-c4765c542bd7"
        class="numbered-list"
        start="6"
      >
        <li>
          최근 3개월 내 이용제한 기록이 있는 이용자가 이용신청을 하는 경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-817a-a63e-ce23c6b35484"
        class="numbered-list"
        start="7"
      >
        <li>
          대한민국 이외의 국가 중 회사에서 아직 서비스를 제공할 것으로 결정하지 않은 국가에서 서비스를 이용하는 경우로 회사가 해외 서비스 업체와 체결한 계약이나 특정 국가에서 접속하는 회원에 대한 서비스 제공과 관련하여 서비스제공을 제한할 필요가 있는 경우
        </li>
      </ol>
      <p id="1271ff38-e4e5-81a7-b59d-e85e12b09e7b" class="">
        ③ 회사는 다음 각 호의 어느 하나에 해당하는 경우에는 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-815e-bf27-d0010ecc21a6"
        class="numbered-list"
        start="1"
      >
        <li>회사의 설비에 여유가 없거나 기술적 장애가 있는 경우</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-818a-8f55-ff9b403e3171"
        class="numbered-list"
        start="2"
      >
        <li>
          서비스 상의 장애 또는 서비스 이용요금 결제수단의 장애가 발생한 경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81dc-a433-ee1a78fdee09"
        class="numbered-list"
        start="3"
      >
        <li>
          그 밖에 위 각 호에 준하는 사유로서 이용신청의 승낙이 곤란한 경우
        </li>
      </ol>
      <p id="1271ff38-e4e5-81e3-b46e-f73dca020d1a" class="">
        <strong>제7조 (회원 정보의 제공 및 변경)</strong>
      </p>
      <p id="1271ff38-e4e5-81d0-b42d-c889d1408574" class="">
        ① 회원은 이 약관에 의하여 회사에 정보를 제공하여야 하는 경우에는 진실된 정보를 제공하여야 하며, 허위정보 제공으로 인해 발생한 불이익에 대해서는 보호받지 못합니다.
      </p>
      <p id="1271ff38-e4e5-8198-bc0a-e023de25eb23" class="">
        ② 회원은 개인정보관리화면을 통하여 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 계정(ID) 등은 수정이 불가능합니다.
      </p>
      <p id="1271ff38-e4e5-81ea-8789-f0528ddde7d4" class="">
        ③ 회원은 회원가입 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 기타 방법으로 회사에 대하여 그 변경사항을 알려야 합니다.
      </p>
      <p id="1271ff38-e4e5-81e3-b12d-e2de66bb7aa2" class="">
        ④ 제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임을 지지 않습니다.
      </p>
      <p id="1271ff38-e4e5-81f4-98d7-c1ba95714cfe" class="">
        <strong>제8조 (개인정보의 보호 및 관리)</strong>
      </p>
      <p id="1271ff38-e4e5-816e-acaa-d63e73fb29e2" class="">
        <strong></strong>
        ① 회사는 관계 법령이 정하는 바에 따라 계정정보를 포함한 회원의 개인정보를 보호하기 위해 노력합니다. 회원 개인정보의 보호 및 사용에 대해서는 관계법령 및 회사가 별도로 고지하는 개인정보취급방침이 적용됩니다.
      </p>
      <p id="1271ff38-e4e5-81c0-b433-c3e9a7bc52ce" class="">
        ② 서비스의 일부로 제공되는 개별 서비스를 제외한 것으로서 어플리케이션 내
        페이지에서 단순히 링크된 제3자 제공의 서비스에 대하여는 회사의 개인정보취급방침이 적용되지 않습니다.
      </p>
      <p id="1271ff38-e4e5-812d-b384-d19dc65a1cfe" class="">
        ③ 회사는 회원의 귀책사유로 인하여 노출된 회원의 계정정보를 포함한 모든 정보에 대해서 일체의 책임을 지지 않습니다.
      </p>
      <p id="1271ff38-e4e5-814f-9d80-cf0a4efd6b6b" class="">
        <strong>제9조 (서비스 이용의 제한)</strong>
      </p>
      <p id="1271ff38-e4e5-812a-a8ee-c1c60b534490" class="">
        <strong></strong>① 회사는 아래 각 호의 1에 해당하는 사유가 발생한
        경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-818b-8d77-f008f33922d9"
        class="numbered-list"
        start="1"
      >
        <li>회원이 회사 서비스 운영을 고의 또는 중과실로 방해하는 경우</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81e3-a33d-ea6f9f203bf2"
        class="numbered-list"
        start="2"
      >
        <li>음란물 유포 및 욕설 등 타인의 서비스 이용에 불편함을 주는 경우</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-816a-8d8f-dd6cd88266e0"
        class="numbered-list"
        start="3"
      >
        <li>회사의 설비 점검, 보수 또는 공사로 인하여 부득이한 경우</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8170-84f4-defe0ea5932b"
        class="numbered-list"
        start="4"
      >
        <li>
          전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을
          경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8143-8fe6-fb0f66e034ce"
        class="numbered-list"
        start="5"
      >
        <li>국가비상사태로 인하여 서비스 이용에 지장이 있는 경우</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8185-8bd2-da6787ddb567"
        class="numbered-list"
        start="6"
      >
        <li>
          기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이
          부적당하다고 인정하는 경우
        </li>
      </ol>
      <p id="1271ff38-e4e5-8123-a9df-edd13c7f6900" class="">
        ② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는
        그 사유 및 제한기간 등을 회원에게 알려야 합니다.
      </p>
      <p id="1271ff38-e4e5-81ea-84da-c3c2883367b5" class="">
        ③ 회원은 서비스 이용 과정에서 본 약관 및 정책에서 금지한 행위를 하거나
        발견한 경우 지체없이 회사에 알려야 하며, 회원이 위 통지의무를 게을리하여
        재산적, 정신적 손해가 발생한 경우 회사는 책임을 부담하지 않습니다.
      </p>
      <p id="1271ff38-e4e5-81ed-9e71-cb5ce38dfa18" class="">
        ④ 회사는 본 약관, 정책, 관계 법령 및 기타 상거래의 일반원칙을 위반한
        회원에 대하여 위반 행위의 경증에 따라 다음과 같은 조치를 할 수 있습니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-8138-9f66-c67088778bfb"
        class="numbered-list"
        start="1"
      >
        <li>
          경고는 최대 2차례 부여될 수 있으며, 즉시 비공개 처리되고 사안의 정도에
          따라 계정이 임시 또는 영구 정지될 수 있습니다.
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-812d-b4f6-ceaeef39233b"
        class="numbered-list"
        start="2"
      >
        <li>
          임시 정지는 24시간부터 최대 3일 동안 부여되며, 사안의 정도에 따라
          계정이 즉시 영구 정지될 수 있습니다.
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8138-9b85-ea1bd88b0282"
        class="numbered-list"
        start="3"
      >
        <li>임시 정지는 서비스 기능 사용 정지를 의미합니다.</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81f6-9d09-d72bc340ec78"
        class="numbered-list"
        start="4"
      >
        <li>
          계정이 영구 정지될 경우 서비스 재가입이 불가능하며, 사안의 정도에 따라
          회사는 사법 및 수사 기관에 관련 자료의 검토를 요청하거나 자료를 넘길
          수 있습니다.
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81ee-8ade-d13a925f76a6"
        class="numbered-list"
        start="5"
      >
        <li>
          본 약관, 정책을 위반하여 계정이 제재, 임시 정지 또는 영구 정지된 경우
          구매한 모든 상품은 어떠한 경우에도 환불이 불가합니다.
        </li>
      </ol>
      <p id="1271ff38-e4e5-8149-905f-da66565d9cff" class="">
        ⑤ 회사가 제 9조 제4항 각 호에 정한 조치를 할 경우 회사는 사전에 회원에게
        서비스 인앱 메시지로 통보하며, 회원의 연락이 두절되거나 긴급을 요하는
        것과 같이 부득이한 경우 선조치 후 통보할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-81bc-8153-f064dfba2b6d" class="">
        ⑥ 회원은 본 조에 의한 회사의 조치에 대하여 항변의 사유가 있는 경우
        회사로부터 전항의 통지를 받은 날로부터 7일 이내에 회사에게 이의제기를 할
        수 있으며, 이의제기의 내용이 정당한 경우 회사는 지체없이 회원에게 취한
        조치를 해제합니다.
      </p>
      <p id="1271ff38-e4e5-8142-a518-d16920f3fac7" class="">
        <strong>제10조 (서비스의 제공 및 중단 등)</strong>
      </p>
      <p id="1271ff38-e4e5-81da-b0eb-e3d511025772" class="">
        ① 본 서비스는 회원간의 매칭을 연결하는 서비스를 제공합니다
      </p>
      <p id="1271ff38-e4e5-8109-994e-e8ed7b279d7a" class="">
        ② 회사는 회사가 제공하는 무료서비스 이용과 관련하여 이용자에게 발생한 어떠한 손해에 대해서도 책임을 지지 않습니다. 다만, 회사의 고의 또는 중대한 과실로 인하여 발생한 손해의 경우는 제외합니다.
      </p>
      <p id="1271ff38-e4e5-8184-88fb-dc3d3bad3b85" class="">
        ③ 본 약관에 따른 서비스 기간은 서비스 가입 신청일부터 이용계약의 해지
        시까지 제공됩니다.
      </p>
      <p id="1271ff38-e4e5-8178-bbcf-c309fe7e2f8e" class="">
        ④ 본 서비스는 업데이트에 따라 사전 공지 없이 기능, 디자인이 변경될 수
        있으며, 필요의 경우 중단될 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8181-95be-e92e997ed532" class="">
        ⑤ 회사가 서비스 내용을 변경하거나 종료하는 경우 회사는 앱 페이지 내 혹은
        회원의 등록된 전자우편을 통해 변경사항을 공지합니다.
      </p>
      <p id="1271ff38-e4e5-8151-a8ff-de18d880a10e" class="">
        <strong>제11조 (정보의 수집 등)</strong>
      </p>
      <p id="1271ff38-e4e5-81f1-8f0e-cd9140bcd45a" class="">
        ① 회사는 서비스 내에서 회원간에 이루어지는 모든 채팅내용을 저장ㆍ보관할 수 있습니다. 회사는 회원간의 분쟁 조정, 민원 처리 또는 서비스
        내 질서 유지를 위하여 회사가 필요하다고 판단하는 경우에 한하여 본 정보를 열람하도록 할 것이며, 본 정보는 회사만이 보유하고 법령으로 권한을 부여 받지 아니한 제3자는 절대로 열람할 수 없습니다. 회사는 해당 정보를 열람하기 전에 채팅정보의 열람이 필요한 사유 및 열람 범위를 개인에게 사전 고지하기로 합니다. 다만, 계정도용, 현금거래, 언어폭력, 서비스 내 사기 등 기망행위, 버그 악용, 기타 현행 법령 위반행위와 관련하여 회원의 채팅 정보를 열람해야 할 필요가 있는 경우에는, 사후에 채팅정보가 열람된 개인들에 대하여 열람한 사유와 열람한 정보 중 본인과 관련된 부분을 고지하기로 합니다.
      </p>
      <p id="1271ff38-e4e5-81b6-ba55-c2bd7b76a73b" class="">
        ② 회사는 서비스 운영 및 프로그램 안정화 등 서비스 품질 개선을 위하여 회원의 모바일
        단말기 설정 및 사양 정보를 수집·활용할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8117-94cc-d8545049d333" class="">
        <strong>제12조 (이용계약의 종료)</strong>
      </p>
      <p id="1271ff38-e4e5-81cc-966d-e98be09082b2" class="">
        <strong></strong>① 회원은 서비스 어플리케이션 내 “서비스 탈퇴“페이지에서
        “서비스 탈퇴하기“를 통해 회원 탈퇴의 의사를 회사에 통지함으로써
        이용계약을 해지할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8136-8d35-dc9c9582cef1" class="">
        ② 회원이 자발적 의사로 이용계약을 해지한 후 재가입을 희망하는 경우에는
        이전 이용계약 해지 후 30일이 경과한 이후에 서비스 재가입이 가능합니다.
      </p>
      <p id="1271ff38-e4e5-8144-b641-cd03375752f0" class="">
        ③ 회사는 다음과 같은 사유가 발생하였거나 확인된 경우 이용계약을 해지할
        수 있습니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-8137-8f6e-e09cdf303d3c"
        class="numbered-list"
        start="1"
      >
        <li>
          회원에게 제6조 제2항 각 호의 사유가 발생하였거나 사후적으로 확인된
          경우
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-815d-a5a6-c718d6f0755c"
        class="numbered-list"
        start="2"
      >
        <li>
          회원에게 제9조 제1항 각 호의 사유가 발생하였거나 사후적으로 확인된
          경우
        </li>
      </ol>
      <p id="1271ff38-e4e5-8174-b4d7-cbe21481489b" class="">
        <strong>제3장 계약 당사자의 의무</strong>
      </p>
      <p id="1271ff38-e4e5-8116-a9f9-c83f65da91a7" class="">
        <strong>제13조 (회사의 의무)</strong>
      </p>
      <p id="1271ff38-e4e5-81ca-b0e3-eda0c751bcd2" class="">
        ① 회사는 관련 법령을 준수하고, 이 약관이 정하는 권리의 행사와 의무의 이행을 신의에 따라 성실하게 합니다.
      </p>
      <p id="1271ff38-e4e5-8199-be48-c4cce092d7e7" class="">
        ② 회사는 회원이 안전하게 서비스를 이용할 수 있도록  개인정보취급방침을 공시하고 준수합니다.
      </p>
      <p id="1271ff38-e4e5-8134-9c0a-c993c6ccde97" class="">
        ③ 회사는 안정적인 서비스의 제공을 위하여  부득이한 사유가 없는 한 이를 수리 또는 복구하도록 최선의 노력을 다합니다.
      </p>
      <p id="1271ff38-e4e5-8171-8fb8-e0e3e96b0e08" class="">
        <strong>제14조 (회원의 의무)</strong>
      </p>
      <p id="1271ff38-e4e5-8149-b440-e285e4d67e32" class="">
        ① 회원은 다음 행위를 하여서는 안 됩니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-8180-8807-fc63c361b928"
        class="numbered-list"
        start="1"
      >
        <li>가입신청 또는 회원 정보 변경 시 허위내용의 기재</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81c4-a829-d96320cc5c48"
        class="numbered-list"
        start="2"
      >
        <li>타인의 정보도용</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81d8-a70b-faf952943030"
        class="numbered-list"
        start="3"
      >
        <li>회사의 임직원, 운영자, 기타 관계자를 사칭하는 행위</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-816b-867f-e1bdc94b22e7"
        class="numbered-list"
        start="4"
      >
        <li>회사가 금지한 정보(컴퓨터 프로그램 등)의 송신 또는 게시</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81ac-b747-db4c903adcc9"
        class="numbered-list"
        start="5"
      >
        <li>
          회사가 제공 또는 승인하지 아니한 컴퓨터 프로그램이나 기기 또는 장치를 제작, 배포, 이용, 광고하는 행위
        </li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8191-b488-edc870eeee44"
        class="numbered-list"
        start="6"
      >
        <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-8127-9d75-c979583cda7a"
        class="numbered-list"
        start="7"
      >
        <li>회사 및 기타 제3자의 명예를 손상 시키거나 업무를 방해하는 행위</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-812a-8c66-e8bf08f01cbc"
        class="numbered-list"
        start="8"
      >
        <li>
          외설 또는 폭력적인 말이나 글, 화상, 음향, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위
        </li>
      </ol>
      <p id="1271ff38-e4e5-816c-94b1-ee63688cb02c" class="">
        11. 제6조 제2항 각 호의 행위를 한 경우
      </p>
      <p id="1271ff38-e4e5-81f3-993f-f0270855d1f9" class="">
        12. 회사의 동의 없이 영리, 영업, 광고, 정치활동 등을 목적으로 서비스를 사용하는 행위
      </p>
      <p id="1271ff38-e4e5-81da-99f4-fb0d28b091cc" class="">
        ② 회원은 이 약관의 규정, 서비스와 관련하여 회사가 통지하는 사항 등을 확인하고 준수할 의무가 있습니다.
      </p>
      <p id="1271ff38-e4e5-812b-95d6-d5fb5c991d8f" class="">
        <strong>제4장 유료 서비스 이용 및 환불</strong>
      </p>
      <p id="1271ff38-e4e5-8186-a9ca-d5f6726fc103" class="">
        <strong>제15조 (유료서비스 내용)</strong>
      </p>
      <p id="1271ff38-e4e5-81ed-8c79-d2273271be5a" class="">
        ① 회사는 회원이 별도 비용지급 없이 이용할 수 있는 서비스(이하 “무료서비스”라 한다)와
        회사가 미리 책정한 요금을 지불하고 이용하는 매칭 관련
        서비스(이하 “유료서비스”라 한다)를 부분적으로 제공하고 있습니다.
      </p>
      <p id="1271ff38-e4e5-81d9-95d2-cde9efb6e4a7" class="">
        ② 회사는 유료 서비스 이용에 대한 대금지급방법을 유료 서비스 이용
        초기화면을 통하여 표시합니다.
      </p>
      <p id="1271ff38-e4e5-81f4-83a5-f3a4dd28d8b0" class="">
        <strong>제16조 (아이템 구매 이용 및 청약철회)</strong>
      </p>
      <p id="1271ff38-e4e5-813b-8ddc-cc934d023c50" class="">
        ① 회원은 애플 앱스토어, 구글 플레이 스토어 또는 딥플에서 승인한 기타
        결제 플랫폼을 통해 아이템을 구매(‘인앱 구매’)하여 서비스 내에서 이용할
        수 있습니다. 다만, 이용시간이 명시되지 않은 경우 해당 아이템의 구매일로
        부터 3년 경과 시
      </p>
      <p id="1271ff38-e4e5-81f5-8842-f48cef504f92" class="">
        소멸됩니다.
      </p>
      <p id="1271ff38-e4e5-819b-8bcf-f5050583330c" class="">
        ② 회원은 ‘결제 방법’(구글 플레이 스토어나 애플 앱스토어 또는 딥플에서
        승인한 기타 결제 플랫폼)에 선택한 서비스에 대한 표시된 가격으로 인앱
        구매 요금 및 결제에 부과될 수 있는 기타 판매세 또는 유사 세금이
        청구됩니다
      </p>
      <p id="1271ff38-e4e5-81dc-a992-f2594592e1a2" class="">
        ③ 아이템을 구매한 이후에 회원 탈퇴 시 구매한 아이템은 자동으로 소멸되며,
        회사는 탈퇴한 회원에게 해당 아이템에 대한 보상을 하지 않습니다. 또한
        회원 탈퇴 후 재가입하더라도 소멸된 아이템은 복구되지 않습니다.
      </p>
      <p id="1271ff38-e4e5-81b3-b878-ec6ad94753a2" class="">
        ④ 법률상 만 20세 미만의
        미성년자인 회원이 결제가 필요한 유료 서비스를 이용하고자 하는 경우 부모 등 법정 대리인의 동의를 얻어야 하고, 동의 없이 이루어진 유료 서비스 이용은 법정대리인이 취소할 수 있습니다.
        다만, 미성년 회원의 기망(거짓)으로 인한 경우 및 법정대리인이 처분을
        허락한 재산의 경우는 제외됩니다.
      </p>
      <p id="1271ff38-e4e5-813d-a082-c65149d11735" class="">
        <strong>제17조 (청약의 철회)</strong>
      </p>
      <p id="1271ff38-e4e5-81c2-81bf-d55849b0f64e" class="">
        ① 회사와 유료서비스 이용에 관한 계약을 체결한 회원은 구매일 또는 유료서비스 이용가능일로부터 7일 이내에는 청약의 철회를 할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8174-a48f-cf21563ea2a9" class="">
        ②회원은 다음 각 호의 어느 하나에 해당하는 경우에는 회사의 의사에 반하여 제1항에 따른 청약철회 등을 할 수 없습니다.
      </p>
      <ol
        type="1"
        id="1271ff38-e4e5-8146-a1d4-d5fe6d6f6efa"
        class="numbered-list"
        start="1"
      >
        <li>회원에게 책임이 있는 사유로 재화 등이 멸실되거나 훼손된 경우</li>
      </ol>
      <ol
        type="1"
        id="1271ff38-e4e5-81ff-8d4c-e2616bfd4c7a"
        class="numbered-list"
        start="2"
      >
        <li>회원이 재화를 소비한 경우</li>
      </ol>
      <p id="1271ff38-e4e5-819b-92c6-f98863226729" class="">
        ③ 회원은 결제 후 환불을 원할 경우, Google Play Store 또는 Apple App
        Store의 환불 요청 절차를 통해 환불을 신청할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8138-99e1-f18f94823f73" class="">
        ④ 개별 서비스의 성격에 따라 회사는 별도 약관 및 이용조건에 따른 취소 및
        환불 규정을 정할 수 있으며, 이 경우 개별 약관 및 이용조건 상의 취소 및
        환불규정이 우선 적용됩니다.
      </p>
      <p id="1271ff38-e4e5-8161-a00f-e686574254f3" class="">
        ⑤ 환불 요청은 결제 후 48시간 이내에 신청해야 하며, 이후 요청에 대해서는
        플랫폼의 환불 정책에 따라 검토됩니다.
      </p>
      <p id="1271ff38-e4e5-81cd-aa65-eb44b65be7a4" class="">
        <strong>제5장 기타</strong>
      </p>
      <p id="1271ff38-e4e5-8143-b23b-df5ef3b8789c" class="">
        <strong>제18조 (회사의 면책)</strong>
      </p>
      <p id="1271ff38-e4e5-8181-8826-dc6df46c4c08" class="">
        ① 회사는 전시, 사변, 천재지변, 비상사태, 현재의 기술로는 해결이 불가능한 기술적 결함 기타 불가항력적 사유로 서비스를 제공할 수 없는 경우에는 책임이 면제됩니다.
      </p>
      <p id="1271ff38-e4e5-8113-a826-decdaadc1b92" class="">
        ②회사는 회원의 귀책사유로 인한 서비스의 중지, 이용장애 및 계약해지에 대하여 책임이 면제됩니다.
      </p>
      <p id="1271ff38-e4e5-8125-b2a0-f68b0572d75c" class="">
        ③회사는 기간통신 사업자가 전기통신서비스를 중지하거나 정상적으로 제공하지 아니하여 회원에게 손해가 발생한 경우에 대해서 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다.
      </p>
      <p id="1271ff38-e4e5-81d7-a53a-c5b9d79277e9" class="">
        ④회사는 사전에 공지된 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 서비스가 중지되거나 장애가 발생한 경우에 대해서 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다.
      </p>
      <p id="1271ff38-e4e5-81cd-b2bd-db40c4fb7e1f" class="">
        ⑤회사는 회원의 컴퓨터 환경으로 인하여 발생하는 제반 문제 또는 회사의 고의 또는 중대한 과실이 없는 네트워크 환경으로 인하여 발생하는 문제에 대해서 책임이 면제됩니다.
      </p>
      <p id="1271ff38-e4e5-817a-a2b8-ebf607048587" class="">
        ⑥회사는 회원 또는 제3자가 서비스 내 또는 웹사이트 상에 게시 또는 전송한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 대해서는 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다.
      </p>
      <p id="1271ff38-e4e5-8176-ac88-eb13f6b99d7a" class="">
        ⑦회사는 회원 상호간 또는 회원과 제3자간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.
      </p>
      <p id="1271ff38-e4e5-818a-8d0a-eec63d2e1496" class="">
        ⑧회사가 제공하는 서비스 중 무료서비스의 경우에는 회사의 고의 또는 중대한 과실이 없는 한 회사는 손해배상을 하지 않습니다.
      </p>
      <p id="1271ff38-e4e5-81b0-b375-d2276551aff3" class="">
        ⑨
        회사는 회원의 컴퓨터 오류에 의한 손해가 발생한 경우 또는 신상정보 및 전자우편주소를 부정확하게 기재하거나 미기재하여 손해가 발생한 경우에 대하여 회사의 고의 또는 중대한 과실이 없는 한 책임이 면제됩니다.
      </p>
      <p id="1271ff38-e4e5-8170-811e-f8852022049f" class="">
        <strong>제19조 (회원의 고충처리 및 분쟁해결)</strong>
      </p>
      <p id="1271ff38-e4e5-8114-a932-c49a488e1cb3" class="">
        ①회사는 회원의 편의를 고려하여 회원의 의견이나 불만을 제시하는 방법을 고객센터나 앱
        내
        페이지에서 안내합니다. 회사는 이러한 회원의 의견이나 불만을 처리하기 위한 전담조직을 운영합니다.
      </p>
      <p id="1271ff38-e4e5-8174-a108-c962ae35295d" class="">
        ②회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 합리적인 기간 내에 이를 신속하게 처리합니다.
      </p>
      <p id="1271ff38-e4e5-8146-9d19-f3a4f3ff54a8" class="">
        ③ 회사와 회원간에 분쟁이 발생하여 제3의 분쟁조정기관이 조정할 경우 회사는 이용제한 등 회원에게 조치한 사항을 성실히 증명하고, 조정기관의 조정에 따를 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-811e-9d1a-c458bc8ff6f2" class="">
        <strong>제20조 (회원에 대한 통지)</strong>
      </p>
      <p id="1271ff38-e4e5-81cb-ada5-c18ade3272d5" class="">
        ① 회사가 회원에게 통지를 하는 경우 회원이 지정한 전자우편주소 등으로 할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8167-bbf5-c5e4df981d64" class="">
        ② 회사는 회원 전체에게 통지를 하는 경우 7일 이상 어플리케이션 내
        초기화면에 게시하거나 팝업화면 등을 제시함으로써 제1항의 통지에 갈음할 수 있습니다.
      </p>
      <p id="1271ff38-e4e5-8155-8805-cb2454f17c1d" class="">
        <strong>제21조 (재판권 및 준거법)</strong>
      </p>
      <p id="1271ff38-e4e5-8135-89a0-ca79adf9887e" class="">
        본 약관은 대한민국 법률에 따라 규율되고 해석되며, 회사와 회원간에 발생한 분쟁으로 소송이 제기되는 경우, 법령에 정한 절차에 따른 법원을 관할 법원으로 합니다.
      </p>
      <p id="1271ff38-e4e5-8127-8d95-e67b8ef5dd1d" class="">
        <strong>부칙</strong>
      </p>
      <p id="1271ff38-e4e5-81e1-a7dd-ca1739c1a065" class="">
        본 약관은 2026년 4월 1일부터 시행합니다.
      </p>
    </div>
  );
}

export default Terms;
